import CodecParser from "./src/CodecParser.js";
import * as constants from "./src/constants.js";

export default CodecParser;

export const absoluteGranulePosition = constants.absoluteGranulePosition;
export const bandwidth = constants.bandwidth;
export const bitDepth = constants.bitDepth;
export const bitrate = constants.bitrate;
export const bitrateMaximum = constants.bitrateMaximum;
export const bitrateMinimum = constants.bitrateMinimum;
export const bitrateNominal = constants.bitrateNominal;
export const buffer = constants.buffer;
export const bufferFullness = constants.bufferFullness;
export const codec = constants.codec;
export const codecFrames = constants.codecFrames;
export const coupledStreamCount = constants.coupledStreamCount;
export const crc = constants.crc;
export const crc16 = constants.crc16;
export const crc32 = constants.crc32;
export const data = constants.data;
export const description = constants.description;
export const duration = constants.duration;
export const emphasis = constants.emphasis;
export const hasOpusPadding = constants.hasOpusPadding;
export const header = constants.header;
export const isContinuedPacket = constants.isContinuedPacket;
export const isCopyrighted = constants.isCopyrighted;
export const isFirstPage = constants.isFirstPage;
export const isHome = constants.isHome;
export const isLastPage = constants.isLastPage;
export const isOriginal = constants.isOriginal;
export const isPrivate = constants.isPrivate;
export const isVbr = constants.isVbr;
export const layer = constants.layer;
export const length = constants.length;
export const mode = constants.mode;
export const modeExtension = constants.modeExtension;
export const mpeg = constants.mpeg;
export const mpegVersion = constants.mpegVersion;
export const numberAACFrames = constants.numberAACFrames;
export const outputGain = constants.outputGain;
export const preSkip = constants.preSkip;
export const profile = constants.profile;
export const protection = constants.protection;
export const rawData = constants.rawData;
export const segments = constants.segments;
export const subarray = constants.subarray;
export const version = constants.version;
export const vorbis = constants.vorbis;
export const vorbisComments = constants.vorbisComments;
export const vorbisSetup = constants.vorbisSetup;
export const blockingStrategy = constants.blockingStrategy;
export const blockSize = constants.blockSize;
export const blocksize0 = constants.blocksize0;
export const blocksize1 = constants.blocksize1;
export const channelMappingFamily = constants.channelMappingFamily;
export const channelMappingTable = constants.channelMappingTable;
export const channelMode = constants.channelMode;
export const channels = constants.channels;
export const copyrightId = constants.copyrightId;
export const copyrightIdStart = constants.copyrightIdStart;
export const frame = constants.frame;
export const frameCount = constants.frameCount;
export const frameLength = constants.frameLength;
export const frameNumber = constants.frameNumber;
export const framePadding = constants.framePadding;
export const frameSize = constants.frameSize;
export const inputSampleRate = constants.inputSampleRate;
export const pageChecksum = constants.pageChecksum;
export const pageSegmentTable = constants.pageSegmentTable;
export const pageSequenceNumber = constants.pageSequenceNumber;
export const sampleNumber = constants.sampleNumber;
export const sampleRate = constants.sampleRate;
export const samples = constants.samples;
export const streamCount = constants.streamCount;
export const streamInfo = constants.streamInfo;
export const streamSerialNumber = constants.streamSerialNumber;
export const streamStructureVersion = constants.streamStructureVersion;
export const totalBytesOut = constants.totalBytesOut;
export const totalDuration = constants.totalDuration;
export const totalSamples = constants.totalSamples;
